import axios, { AxiosError } from 'axios';
import { API_DEVICE_BY_GROUP } from '../../const/const';

export const getDeviceByGroup = async (
    SmartDVRToken: string,
    userLogin: string,
    groupUID: string,
    page?: number,
    quantity?: number,
) => {
    if (!userLogin || !SmartDVRToken) {
        throw new Error('User information is missing.');
    }

    try {
        const response = await axios.get(
            API_DEVICE_BY_GROUP(groupUID, page, quantity),
            {
                headers: {
                    SmartDVRLogin: userLogin,
                    SmartDVRToken: SmartDVRToken,
                },
            },
        );
        const data = response.data;
        if (!data || !data.data) {
            throw new Error('Invalid response from server');
        }
        return data;
    } catch (error) {
        const err = error as AxiosError;
        console.error('Error fetching devices:', err.response?.status, err.response?.data);
        throw new Error(
            `Failed to fetch devices: ${err.response?.status} ${(err.response?.data as any)?.error || err.message}`,
        );
    }
};
